module.exports = __webpack_public_path__ + "img/community3@2x.fd63d1ef.png";